import {DraggableTree} from 'vue-draggable-nested-tree'
import ViewDetail from '../group-checklist-item/view-detail'
import EditGroup from '../group-checklist-item/edit'
import CreateChildren from '../group-checklist-item/create-child'
import swal from 'sweetalert'
import AddRoot from '../group-checklist-item/create'
import ListChecklistItem from '../list-checklist-item'
export default {
  name: 'list',
  components: {
    Tree: DraggableTree,
    ViewDetail,
    EditGroup,
    CreateChildren,
    AddRoot,
    ListChecklistItem
  },
  props: [],
  data () {
    return {
      select: null
    }
  },
  destroyed () {
    this.$store.dispatch('ChecklistItem/openView')
  },
  computed: {
    data () {
      return this.$store.getters['GroupChecklistItem/getListGroupChecklistItem']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    },
    showEdit () {
      return this.$store.getters['ChecklistItem/getOpenEdit']
    },
    showChecklistItem () {
      return this.$store.getters['ChecklistItem/getOpenChecklistItem']
    },
    showCreateChildren () {
      return this.$store.getters['ChecklistItem/getOpenCreateChildren']
    },
    showViewInfo () {
      return this.$store.getters['ChecklistItem/getOpenView']
    },
    can_drop () {
      var permission = this.$store.getters['Profile/getPermission']
      var groupId = this.$store.getters['Profile/getGroup']
      return permission.indexOf(this.$permissions.UPDATE_GROUPCHKITEM) !== -1 || groupId === 1
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('GroupChecklistItem/getListGroupChecklistItem', {page: 1, per_page: 'all'}),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {
      this.select = this.data[0]
      this.$store.dispatch('ChecklistItem/getListChecklistItem', {page: 1, per_page: 100, status: this.status, search: this.search, sort: this.sort, group: this.select.id})
    }).catch(errors => {
    })
  },
  methods: {
    ondrag (node) {
      if (node.parent.id !== undefined) {
        node.parent_id = node.parent.id
      } else {
        node.parent_id = 0
      }
      this.group_checklist_item = {}
      this.group_checklist_item.parent_id = node.parent_id
      this.group_checklist_item.id = node.id
      this.group_checklist_item.header = node.header
      this.group_checklist_item.index = node.index ? node.index : '&nbsp;'
      this.$store.dispatch('GroupChecklistItem/updateGroupChecklistItem', {group_checklist_item: this.group_checklist_item}).then(res => {
      }).catch(errors => {
      })
    },
    showView () {
      this.$store.dispatch('ChecklistItem/openView')
    },
    openChecklistItem (group) {
      Promise.all([
        this.$store.dispatch('ChecklistItem/getListChecklistItem', {page: 1, per_page: 100, status: this.status, search: this.search, sort: this.sort, group: group.id})
      ]).then(res => {
        this.$store.dispatch('ChecklistItem/openChecklistItem')
      }).catch(errors => {
      })
    },
    showAddModal () {
      this.$store.dispatch('ChecklistItem/openCreateChildren')
    },
    showEditModal () {
      this.$store.dispatch('ChecklistItem/openEdit')
    },
    selected (data) {
      Promise.all([
        this.$store.dispatch('ChecklistItem/getListChecklistItem', {page: 1, per_page: 100, status: this.status, search: this.search, sort: this.sort, group: data.id})
      ]).then(res => {
        this.select = data
        this.$store.dispatch('ChecklistItem/openChecklistItem')
      }).catch(errors => {
      })
      // this.$store.dispatch('ChecklistItem/openView')
    },
    listCheckListItem () {
      this.$router.push('/checklist-item/list?group_checklist_item_id=' + this.data.id)
    },
    destroy (data) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$store.dispatch('GroupChecklistItem/destroyGroupChecklistItem', {
              group_checklist_item: data
            }).then((res) => {
              this.select = this.data[0]
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$emit('destroySuccess')
            })
          }
        })
    },
    showAddRootModal () {
      this.$refs.rootModel.show()
    },
    createSuccess (data) {
      this.select = data
    },
    updataSuccess (data) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist-item/list/list.js